<template>
	<div class="bg-white px-3 goods_create" style="margin-left: -20px;margin-bottom: 0!important;overflow-y: scroll;height: 35vh">

		<el-form ref="form" label-width="80px" >
      <div v-show="false">

			<div class="d-flex pt-a">
				<div style="width: 25%;">
					<el-form-item label="客户名称">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" @change="curr" :disabled="lists.id != 0 ? true : false">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="客户简称">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" @change="curr" :disabled="lists.id != 0 ? true : false">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.j_name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="出仓账号">
						<div style="color: #0091ff;">{{user.name}}</div>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="日期">
						<el-date-picker v-model="lists.ddrq" align="right" type="date" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 90%;" :picker-options="pickerOptions">
						</el-date-picker>
					</el-form-item>
				</div>
			</div>
			<div class="d-flex">
				<div style="width: 25%;">
					<el-form-item label="货运方式">
						<el-select v-model="lists.thlx" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in hyfslist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="仓库">
						<el-select v-model="lists.ck_id" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="送货时间" v-if="lists.thlx == 2">
						<el-date-picker v-model="lists.shsj" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" size="mini" style="width: 95%;">
						</el-date-picker>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="备注">
						<el-input v-model="lists.desc" style="width: 95%;" type="textarea" :rows="2"></el-input>
					</el-form-item>
				</div>

			</div>
			<div class="d-flex">
				<div style="width: 25%;">
					<el-form-item label="是否专车" v-if="lists.thlx == 4">
						<el-radio-group v-model="lists.thlx_sl_zc" size="mini" @change="yfjs">
							<el-radio-button label="0">否</el-radio-button>
							<el-radio-button label="1">是</el-radio-button>
						</el-radio-group>
					</el-form-item>
				</div>
			</div>
			<div v-if="lists.thlx == 13" style="margin-bottom: 20px;">
				<!-- <div style="color: #676767;font-size: 13px;margin-top: 10px;">请填写以下货运站信息</div>
				<div class="d-flex">
					<div style="width: 33%;">
						<el-form-item label="货运站">
							<el-select v-model="lists.hyz_id" filterable style="width: 90%;" size="mini">
							    <el-option v-for="item in hyzlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="手机">
							<el-input placeholder="请输手机号码" v-model="lists.hyz_dh" clearable size="mini" style="width: 96%;"></el-input>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="车牌/地址">
							<el-input placeholder="请输车牌或地址" v-model="lists.hyz_dz" clearable size="mini" style="width: 96%;"></el-input>
						</el-form-item>
					</div>
				</div> -->
				<div style="color: #676767;font-size: 13px;margin-top: 10px;">请填写以下收货人信息</div>
				<div class="d-flex">
					<div style="width: 33%;">
						<el-form-item label="收货人">
							<el-input placeholder="请输收货人姓名" v-model="lists.shr_xm" clearable size="mini" style="width: 96%;"></el-input>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="手机">
							<el-input placeholder="请输手机号码" v-model="lists.shr_dh" clearable size="mini" style="width: 96%;"></el-input>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="收货地址">
							<el-input placeholder="请输收货地址" v-model="lists.shr_dz" clearable size="mini" style="width: 96%;"></el-input>
						</el-form-item>
					</div>
				</div>
			</div>

      </div>
      <div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;margin-bottom: 20px">
        <div class="">
					<el-table :data="ccddhw" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
						<el-table-column align="center" width="66" fixed="left">
							<template slot="header" slot-scope="scope">
								<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustyl"></el-button>
							</template>
							<template slot-scope="scope">
								<el-button type="danger" size="mini" icon="el-icon-delete" @click="pustyldel(scope.$index)"></el-button>
							</template>
						</el-table-column>
						<el-table-column type="index" label="序号" width="46" align="center" fixed="left"></el-table-column>
						<el-table-column prop="hwmc" label="货物名称" fixed="left"></el-table-column>
						<el-table-column label="客称" width="100" prop="kc"></el-table-column>
						<el-table-column prop="bh" label="条码" width="100" align="center"></el-table-column>
						<el-table-column label="包装叫法" width="100" prop="bzjf"></el-table-column>
						<el-table-column label="包装" align="center" width="80" prop="hwbz"></el-table-column>
						<el-table-column label="件数" align="center" width="130">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.js" style="width: 90%;" :min='0' :max='scope.row.kcjs' @change="handjstj(scope.$index,scope.row.js,scope.row.djzl,scope.row.djmj,scope.row.djtj)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="zmj" label="总面积(平方)" align="center" width="96"></el-table-column>
						<el-table-column prop="ztj" label="总体积(立方)" align="center" width="96"></el-table-column>
						<el-table-column prop="zzl" label="总重量(kg)" align="center" width="96"></el-table-column>
						<el-table-column label="单件重量(kg)" align="center" width="96" prop="djzl"></el-table-column>
						<el-table-column label="单件面积" align="center" width="96" prop="djmj"></el-table-column>
						<el-table-column label="单件体积" align="center" width="96" prop="djtj"></el-table-column>
					</el-table>
				</div>
			</div>
		</el-form>
		<el-dialog title="选择库存" :visible.sync="createModel" top="5vh" customClass="customWidth" width="80%">
			<button-search class="" placeholder="货物名称" @search="searchEvent">
				<template #form>
					<el-form inline ref="form" :model="search" label-width="80px">
						<!-- 搜索内容 -->
						<el-form-item label="货物编号" class="mb-0">
							<el-input v-model="search.bh" size="mini" placeholder="货物编号"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
							<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>
					</el-form>
				</template>
			</button-search>
			<div style="width: 100%;" class="d-flex">
				<el-table ref="multipleTable" :data="ckcplist" tooltip-effect="dark" height="420" size="mini" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="bh" label="编号" width="120"></el-table-column>
					<el-table-column prop="hwmc" label="货物名称" width="80"></el-table-column>
					<el-table-column prop="kc" label="客称" width="120"></el-table-column>
					<el-table-column prop="bzjf" label="包装叫法" width="120"></el-table-column>
					<el-table-column prop="hwmc" label="货物包装" width="100">
						<template slot-scope="scope">
							{{scope.row.hwbzlx == null ? '' : scope.row.hwbzlx.name}}
						</template>
					</el-table-column>
					<el-table-column prop="sl" label="计费数量" align="center"></el-table-column>
					<el-table-column prop="js" label="总件数" align="center"></el-table-column>
					<el-table-column prop="bsl" label="总板数" align="center"></el-table-column>
					<el-table-column prop="mj" label="总面积" align="center"></el-table-column>
					<el-table-column prop="tj" label="总体积" align="center"></el-table-column>
					<el-table-column prop="zl" label="总重量" align="center"></el-table-column>
				</el-table>
			</div>
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="1" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submits(multipleSelection)">确 定</el-button>
			</div>
		</el-dialog>
		<el-footer class="border-top d-flex align-items-center px-0  bg-white" style="margin-left: -20px;width: 100%">
			<div style="width: 160px;margin-left: 30px;">经办人：<span style="color: #0091ff;">{{lists.cjrname}}</span></div>
			<div style="width: 110px;">共<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{lists.hwxm}}</span>项</div>
			<div style="width: 140px;">
				出仓件数：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{ccjs}}</span>
			</div>
			<div style="width: 180px;">
				出仓重量：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{cczl}}</span>吨
			</div>
			<div style="width: 160px;">
				出仓面积：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{ccmj}}</span>
			</div>
			<div style="width: 160px;">
				出仓体积：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{cctj}}</span>
			</div>
			<div style="width: 160px;">
				运费：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{zyf}}</span>元
			</div>
			<el-button type="primary" @click="submit" style="margin-left: 5%;">提交</el-button>
		</el-footer>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import buttonSearch from '@/components/common/button-search.vue';
	import common from '@/common/mixins/common.js';
	export default {
		mixins: [common],
		inject: ['app', 'layout'],
		components: {
			buttonSearch
		},
    props:{
      lists:[]
    },
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}]
				},
				ccjs:0,
				ccmj:0,
				cctj:0,
				cczl:0,
				zyf:0,
				ywylist:[],
				khlist:[],
				cklist:[],
				ckcplist:[],
				bmlist:[],
				valuea: false,
				createModel: false,
				preUrl: 'khkc',
				multipleSelection:[],
				ccddhw:[],


				lmfdw:'',
				tableDatab:[],

				hwlxlist:[],
				hyfslist:[],
				jfdwlist:[],
				jfbzlist:[],
				hwbzlist:[],
				hyzlist:[],
				jfzqlist: [{
					id: 1,
					name: '1天'
				}, {
					id: 3,
					name: '3天'
				}, {
					id: 7,
					name: '7天'
				}, {
					id: 10,
					name: '10天'
				}],
				ddsxlist: [{
					id: 0,
					name: '散货'
				}, {
					id: 1,
					name: '大货'
				}],
				jfmslist: [{
					id: 0,
					name: '重量'
				}, {
					id: 1,
					name: '体积'
				}],
				flfylxlist: [],
				search: {
					keyword: "",
					bh:''
				},
				bantj:1.68 ,//每板体积
				dqkhxx:{} // 当前客户信息
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			}),



		},
    watch:{
      lists(newVal, oldVal){
        this.init()
      }
    },

		methods: {
      init() {

        this.ccmj = this.lists.ccmj
        this.ccjs = this.lists.ccjs
        this.cctj = this.lists.cctj
        this.cczl = this.lists.cczl
        this.zyf = this.lists.zyf
        if(this.lists.hwxm != 0){
          this.ccddhw = this.lists.ccddhw
        }

        this.axios.get('/admin/flflx/1', { token: true }).then(res => {
          this.flfylxlist = res.data.data.list;
        });
        this.axios.get('/admin/hyxl/1', { token: true }).then(res => {
          this.hyzlist = res.data.data.list;
        });
        this.axios.get('/admin/thlx/1', { token: true }).then(res => {
          this.hyfslist = res.data.data.list;
        });
        this.axios.get('/admin/khxxsrcdd', { token: true }).then(res => {
          this.khlist = res.data.data;
        });
        this.axios.get('/admin/cangkus', { token: true }).then(res => {
          this.cklist = res.data.data;
        });

        this.axios.get('/admin/hwlx/1', { token: true }).then(res => {
          this.hwlxlist = res.data.data.list;
        });
        this.axios.get('/admin/jfdw/1', { token: true }).then(res => {
          this.jfdwlist = res.data.data.list;

        });

        this.axios.get('/admin/jfbz/1', { token: true }).then(res => {
          this.jfbzlist = res.data.data.list;
        });

        this.axios.get('/admin/hwbz/1', { token: true }).then(res => {
          this.hwbzlist = res.data.data.list;
        });

      },
			curr(val){
				let data = this.khlist.filter(item=>{
					return item.id == val
				})
				this.dqkhxx = data[0]
				this.lists.bh = data[0].j_name+'-'+data[0].cfpc
				this.lists.pch = data[0].cfpc
				this.lists.lmfdj = data[0].lmf_dj
				this.lists.jfdw = data[0].jfdw_id
				this.lists.jfzq = data[0].jfzq
				this.lists.yfdj = data[0].yfdj
				this.lists.flfylx = data[0].flflx_id
				this.lists.zgcf = data[0].gcf_dj
				this.lists.thlx = data[0].hyfs
				let datas = this.jfdwlist.filter(item=>{
					return item.id == data[0].jfdw_id
				})
				this.lmfdw = datas[0].name
				this.lists.hyz_id = data[0].xl_id
			},

			pustyl() {
				if(!this.lists.kh_id){
					this.$message({
						type: "warning",
						message: "请先选择客户"
					})
				}else{
					this.getList()
					this.createModel = true;
				}
			},
			pustyldel(e) {
				this.ccddhw.splice(e,1)
			},
			submits(e) {
				for(let i of e){
					let data = {
						kc_id:i.id,
						bh:i.bh,
						kh_id:i.kh_id,
						hwmc:i.hwmc,
						bzjf:i.bzjf,
						hwbz:i.hwbzlx.name,
						bsl:i.bsl,
						kcjs:i.js,
						kc:i.kc,
						djmj:i.djmj,
						djtj:i.djtj,
						djzl:i.djzl,
						js:0,
					}
					this.ccddhw.push(data)
				}
				this.lists.hwxm = this.ccddhw.length
				this.createModel = false;
			},
			getListUrl() {
				return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&keyword=${this.search.keyword}&bh=${this.search.bh}&kh_id=${this.lists.kh_id}&ck_id=${this.lists.ck_id}`
			},
			getListResult(e) {
				this.ckcplist = e.list;
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},


			handjstj(index,js,zl,mj,tj){
				this.ccddhw[index].zzl = (js * parseFloat(zl)/1000).toFixed(2)
				this.ccddhw[index].zmj = (js * parseFloat(mj)).toFixed(2)
				this.ccddhw[index].ztj = (js * parseFloat(tj)).toFixed(2)
				let bzdsl = Math.floor(this.bantj / parseFloat(this.ccddhw[index].djtj))
				this.ccddhw[index].bsl = Math.ceil(js / bzdsl).toFixed(2)
				this.yfjs()
			},
			yfjs(){
				this.lists.rcddhw = this.rcddhw
				let ccjs = 0
				let cczl = 0
				let ccmj = 0
				let cctj = 0
				for(let i of this.ccddhw){
					ccjs += parseFloat(i.js)
					cczl += parseFloat(i.zzl)
					cctj += parseFloat(i.ztj)
					ccmj += parseFloat(i.zmj)
				}
				this.ccjs = ccjs
				this.ccmj = ccmj.toFixed(2)
				this.cctj = cctj.toFixed(2)
				this.cczl = cczl.toFixed(2)

				this.lists.ccjs = this.ccjs
				this.lists.ccmj = this.ccmj
				this.lists.cctj = this.cctj
				this.lists.cczl = this.cczl

				// 运费
				let yufei = 0
				if(this.lists.thlx == 2){ // 班车
					if(this.dqkhxx.hyfs_bcdw == 1){ // 单位：件
						yufei = parseFloat(this.dqkhxx.hyfs_dj) * ccjs
						if(yufei < 3){
							// 保底3元
							yufei = 3
						}else if(yufei >= 80 && yufei < 160){
							// 满80元打9折
							yufei = Math.round(yufei * (9 / 10))
						}else if(yufei >= 160 && yufei < 240){
							// 满160元打8折
							yufei = Math.round(yufei * (8 / 10))
						}else{
							// 满240元打7.5折
							yufei = Math.round(yufei * (7.5 / 10))
						}
					}else{ // 单位：吨
						yufei = 80 * cczl
						if(yufei < 3){
							// 保底3元
							yufei = 3
						}else if(yufei >= 80 && yufei < 160){
							// 满80元打9折
							yufei = Math.round(yufei * (9 / 10))
						}else if(yufei >= 160 && yufei < 240){
							// 满160元打8折
							yufei = Math.round(yufei * (8 / 10))
						}else{
							// 满240元打7.5折
							yufei = Math.round(yufei * (7.5 / 10))
						}
					}
					this.lists.zyf = yufei
				}else if(this.lists.thlx == 1){ // 自提 默认运费为0
					this.lists.zyf = yufei
				}else if(this.lists.thlx == 3){ // 黄沙
					let newhwds = cczl * 1000
					if(newhwds <= 200){ // 200公斤内 30元
						yufei = 30
					}else if(newhwds > 201 && newhwds <= 300){ // 201公斤-300公斤 40元
						yufei = 40
					}else if(newhwds > 301 && newhwds <= 400){ // 301公斤-400公斤 50元
						yufei = 50
					}else if(newhwds > 401 && newhwds <= 500){ // 401公斤-500公斤 60元
						yufei = 60
					}else if(newhwds > 501 && newhwds <= 1000){ // 501公斤-1000公斤 70元
						yufei = 70
					}else if(newhwds > 1001 && newhwds <= 1200){ // 1001公斤-1200公斤 80元
						yufei = 80
					}else if(newhwds > 1201 && newhwds <= 1400){ // 1201公斤-1400公斤 100元
						yufei = 100
					}else if(newhwds > 1401 && newhwds <= 1600){ // 1401公斤-1600公斤 110元
						yufei = 110
					}else if(newhwds > 1601 && newhwds <= 1800){ // 1601公斤-1800公斤 130元
						yufei = 130
					}else if(newhwds > 1801 && newhwds <= 2000){ // 1801公斤-2000公斤 140元
						yufei = 140
					}else if(newhwds > 2001 && newhwds <= 4000){ // 2001公斤-4000公斤 160元
						yufei = 160
					}
					this.lists.zyf = yufei
				}else if(this.lists.thlx == 4){ // 省冷
					if(this.lists.thlx_sl_zc == 1){ // 专车 (待补充)
						yufei = 200
						this.lists.zyf = yufei
					}else{ // 非专车
						let newtj = ((cczl * 1000) / cctj) * 2 // 平均每2立方的重量kg
						if(newtj < 700){ // 2立方体积重量为700Kg（不含）以下的，60元/吨
							yufei = Math.round(cczl * 60)
						}else{
							yufei = Math.round(cczl * 40)
						}
						if(yufei < 50){
							yufei = 50
						}
					}

				}
				// 运费时间-优惠
				var now = new Date();
				var hour = now.getHours();
				if(hour >=12 && hour < 18){
					this.lists.zyf = Math.round(yufei * (8.5 / 10))
				}else{
					this.lists.zyf = Math.round(yufei * (9 / 10))
				}
				this.lists.zyf = yufei
				this.zyf = this.lists.zyf

			},
			// 搜索事件
			searchEvent(e = false) {
				// 简单搜索
				if (typeof e === 'string') {
					this.search.keyword = e
					this.getList()
					return
				}
				// 高级搜索
				this.getList()
			},
			// 清空筛选条件
			clearSearch() {
				this.search = {
					keyword: "",
					bh: '',
				}
			},
			//提交
			submit() {
				if(this.lists.hwxm != 0){
					this.lists.ccddhw = this.ccddhw
				}
				let x = this.lists
				x.thm = this.dqkhxx.thm
				x.thm_url = this.dqkhxx.thm_url
				this.layout.showLoading()
				let url = this.lists.id === 0 ? '/admin/ccdd_sqd' : '/admin/ccdd_sqd/' + this.lists.id

				this.axios.post(url, x, {
					token: true
				}).then(res => {
					console.log(res);
					this.$message({
						type: "success",
						message: this.lists.id === 0 ? "下单成功" : "修改成功"
					})
          this.$emit("submitOk")
					this.layout.hideLoading()

				}).catch(err => {
					this.layout.hideLoading()
				})
			}
		},
	}
</script>

<style>
	.goods_create .el-form-item {
	    margin-bottom: 4px !important;
	}
	.pt-a{
		padding-top: 20px;
	}
	.el-form-item__label {
		width: 84px !important;
	}
</style>
